// Amazon Ads accountInfo.subType of a Kindle Direct Publishing author profile (a vendor profile without SP-API).
export const KDP_AUTHOR = "KDP_AUTHOR";
